import React, { Fragment } from "react";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { Typography } from "@mui/material";
import CommonButton from "../../../../component/Button";
import AddIcon from "@mui/icons-material/Add";
import CommonTable from "../../../candidates/Table";
import DropDownSelect from "../../../../component/Select";

export default function CandidateResult({
  resultData,
  handleSerchAgain,
  handleHubTableBodyData,
  handleSearchTableBodyData,
  handleDetails,
  handleAddToJob,
  checkSelected,
  handleAddToExternal,
  processConditionCheck,
  title,
  condition = true,
  handlePageChange,
  handleDropdownChange = {},
  CustomMenuItem = {},
  externalValidating
}) {
  return (
    <Fragment>
      {condition && (
        <CommonGrid2
          display={"flex"}
          justifyContent={"space-between"}
          gap={"8px"}
          marginTop={"2rem"}
        >
          <Typography variant="h3" fontWeight={700}>
            {title || "Candidate Sourcing"}
          </Typography>

          <CommonGrid2
            display={"flex"}
            justifyContent={"space-between"}
            gap={"1rem"}
          >
            <CommonButton
              value={"Search Again"}
              variant="outlined"
              color="#344054"
              padding={"8px 1.5rem"}
              fontWeight={"600"}
              fontSize={"15px"}
              border={"#D0D5DD"}
              disabled={processConditionCheck || resultData.loading}
              loading={resultData.searhLoading}
              onClick={handleSerchAgain}
            />
            <CommonButton
              fontWeight="600"
              startIcon={<AddIcon />}
              gap={"0px"}
              value={"Add to Job"}
              padding={"8px 1.5rem"}
              disabled={
                processConditionCheck ||
                resultData.loading ||
                (checkSelected && checkSelected.candidateSelect.length === 0)
              }
              onClick={handleAddToJob}
            />
          </CommonGrid2>
        </CommonGrid2>
      )}

      {resultData.data.map((item, index) => (
        <CommonGrid2 marginBottom={"2rem"} marginTop={item.marginTop}>
          <CommonGrid2
            display={"flex"}
            flexWrap={"wrap"}
            justifyContent={"space-between"}
            marginTop={item.sort ? "1rem" : "0px"}
          >
            <Typography variant="h6" fontWeight={item.fontWeight}>
              {item.title}
            </Typography>
            {item.sort && (
              <DropDownSelect
                marginTop="0px"
                customStyle={{
                  width: "200px",
                }}
                disabled={resultData.loading}
                title={"Sort by"}
                data={item.sort_data}
                value={item?.sort_data_value?.name || ""}
                handleChange={handleDropdownChange}
                CustomMenuItem={CustomMenuItem}
              />
            )}
            {item.button && (
              <CommonButton
                value={item.button}
                fontWeight="700"
                startIcon={!externalValidating && <AddIcon />}
                gap={!externalValidating ? "0px" : "8px"}
                padding={"8px 1.5rem"}
                disabled={
                  processConditionCheck ||
                  resultData.loading ||externalValidating ||
                  (checkSelected && checkSelected.externalSelect.length === 0)
                }
                loading={externalValidating}
                onClick={() => handleAddToExternal()}
              />
            )}
          </CommonGrid2>
          <CommonTable
            marginTop="1rem"
            data={
              item.details === "See More"
                ? (item.data && item.data.slice(0, 3)) || []
                : item.data || []
            }
            columns={item.header}
            loadingRowLength={3}
            handleTableBodyData={
              index === 0 ? handleHubTableBodyData : handleSearchTableBodyData
            }
            withPagination={item.withPagination}
            loading={resultData.loading}
            paginationProps={{
              count: item.totalPage,
              page: item.currentPage,
              onPageChange: (page) => {
                handlePageChange(page);
              },
            }}
          />
          {item.data && item.data.length !== 0 && item.data.length > 3 && (
            <CommonGrid2 margin={"0.5rem"} textAlign={"end"}>
              <CommonButton
                value={item.details}
                variant="outlined"
                color="#6941C6"
                border="transparent"
                fontWeight="700"
                padding={"6px 20px"}
                onClick={() => handleDetails(index, item)}
              />
            </CommonGrid2>
          )}
        </CommonGrid2>
      ))}
    </Fragment>
  );
}
